module.exports = __WEBPACK_EXTERNAL_MODULE_295__;


//////////////////
// WEBPACK FOOTER
// external "comsMobx"
// module id = 295
// module chunks = 66